import { useLingui } from '@lingui/react/macro';

import type { ImageQualityFinding } from '@/utils/claimSummary/imageFindings';

function useFindingTranslations(finding: ImageQualityFinding) {
  const { t } = useLingui();
  const { findingKind, teethList } = finding;

  const title =
    findingKind === 'overlap_left_bitewings'
      ? t`Interproximal overlap (left bitewings)`
      : findingKind === 'overlap_right_bitewings'
        ? t`Interproximal overlap (right bitewings)`
        : findingKind === 'root_tips_not_visible'
          ? t`Root tips not visible`
          : findingKind === 'edges_cut_off'
            ? t`Teeth cut off at edges`
            : findingKind === 'additional_imaging_required'
              ? t`Teeth missing or unclear`
              : findingKind === 'cej_not_visible'
                ? t`CEJ not visible`
                : finding.title;

  const description =
    findingKind === 'overlap_left_bitewings' ||
    findingKind === 'overlap_right_bitewings'
      ? t`Overlap detected on bitewing image(s).`
      : findingKind === 'root_tips_not_visible'
        ? t`Root tips not visible for #${teethList ?? ''}.`
        : findingKind === 'edges_cut_off'
          ? t`Teeth cut off at edges for #${teethList ?? ''}.`
          : findingKind === 'additional_imaging_required'
            ? t`Teeth #${teethList ?? ''} are missing or unclear.`
            : findingKind === 'cej_not_visible'
              ? t`CEJ not visible for #${teethList ?? ''}.`
              : finding.description;

  return { title, description };
}

interface FindingItemProps {
  finding: ImageQualityFinding;
}

export const FindingItem = ({ finding }: FindingItemProps) => {
  const { title, description } = useFindingTranslations(finding);

  return (
    <div className="vai-flex vai-items-center vai-gap-3 vai-py-3 vai-px-3 vai-bg-zinc-900 vai-border vai-border-zinc-700 vai-rounded-lg vai-mb-2 last:vai-mb-0">
      <div className="vai-flex vai-flex-col vai-gap-1 vai-flex-1 vai-min-w-0">
        <span className="vai-text-white vai-text-sm vai-font-semibold vai-leading-snug">
          {title}
        </span>
        <span className="vai-text-zinc-500 vai-text-xs vai-leading-snug">
          {description}
        </span>
      </div>
    </div>
  );
};
